import { CommonNS } from "../../../../Common/CommonNS.js";
import { VONS } from "../../VO/VONS.js";
export class CommandZ {
  constructor() {
    this._prev_command = null;
    this._initial_point_observer_set = new Set();
    this._initial_point_vo = {
      x: 0,
      y: 0,
    };
    this._initial_point_subscription = null;
    this._initial_point_is_show_observer_set = new Set();
    this._initial_point_is_show = false;
    this._initial_point_is_show_subscription = null;
    this._initial_point_is_selected_observer_set = new Set();
    this._initial_point_is_selected = false;
    this._initial_point_is_selected_subscription = null;
  }
  subscribeTargetPoint(observer) {
    return this.subscribeInitialPoint(observer);
  }
  subscribeTargetPointIsShow(observer) {
    return this.subscribeInitialPointIsShow(observer);
  }
  subscribeTargetPointIsSelected(observer) {
    return this.subscribeInitialPointIsSelected(observer);
  }
  subscribeInitialPoint(observer) {
    if (this._initial_point_observer_set.has(observer)) {
      throw new Error(`이미 등록된 observer 입니다.`);
    }
    observer(this._initial_point_vo);
    this._initial_point_observer_set.add(observer);
    return () => {
      this._initial_point_observer_set.delete(observer);
    };
  }
  subscribeInitialPointIsShow(observer) {
    if (this._initial_point_is_show_observer_set.has(observer)) {
      throw new Error(`이미 등록된 observer 입니다.`);
    }
    observer(this._initial_point_is_show);
    this._initial_point_is_show_observer_set.add(observer);
    return () => {
      this._initial_point_is_show_observer_set.delete(observer);
    };
  }
  subscribeInitialPointIsSelected(observer) {
    if (this._initial_point_is_selected_observer_set.has(observer)) {
      throw new Error(`이미 등록된 observer 입니다.`);
    }
    observer(this._initial_point_is_selected);
    this._initial_point_is_selected_observer_set.add(observer);
    return () => {
      this._initial_point_is_selected_observer_set.delete(observer);
    };
  }
  setPrevCommand(prev_command) {
    this._initial_point_subscription?.();
    this._initial_point_subscription = null;
    this._initial_point_is_show_subscription?.();
    this._initial_point_is_show_subscription = null;
    this._initial_point_is_selected_subscription?.();
    this._initial_point_is_selected_subscription = null;
    this._prev_command = prev_command;
    if (prev_command == null) {
      this._initial_point_vo = {
        x: 0,
        y: 0,
      };
      this._initial_point_is_show = false;
      this._initial_point_is_selected = false;
      this._notifyInitialPoint(this._initial_point_vo);
      this._notifyInitialPointIsShow(this._initial_point_is_show);
      this._notifyInitialPointIsSelected(this._initial_point_is_selected);
      return;
    }
    this._initial_point_subscription = prev_command.subscribeInitialPoint(
      (vo) => this._observeInitialPoint(vo)
    );
    this._initial_point_is_show_subscription =
      prev_command.subscribeInitialPointIsShow((is_show) =>
        this._observeInitialPointIsShow(is_show)
      );
    this._initial_point_is_selected_subscription =
      prev_command.subscribeInitialPointIsSelected((is_selected) =>
        this._observeInitialPointIsSelected(is_selected)
      );
  }
  toString() {
    const prev_str = this._prev_command?.toString();
    const str = "Z";
    return `${prev_str ? `${prev_str} ` : ""}${str}`;
  }
  click(click_vo) {}
  showTargetPoint() {
    this.showInitialPoint();
  }
  showInitialPoint() {
    this._prev_command?.showInitialPoint();
  }
  transform(matrix) {}
  getIsSelected() {
    return this._initial_point_is_selected;
  }
  getIsTargetPointSelected() {
    return this._initial_point_is_selected;
  }
  getTargetPoint() {
    return this._initial_point_vo;
  }
  moveTargetPoint(point) {}
  _notifyInitialPoint(point_vo) {
    for (const observer of this._initial_point_observer_set) {
      CommonNS.UtilNS.tryNoop(() => observer(point_vo));
    }
  }
  _notifyInitialPointIsShow(is_show) {
    for (const observer of this._initial_point_is_show_observer_set) {
      CommonNS.UtilNS.tryNoop(() => observer(is_show));
    }
  }
  _notifyInitialPointIsSelected(is_selected) {
    for (const observer of this._initial_point_is_selected_observer_set) {
      CommonNS.UtilNS.tryNoop(() => observer(is_selected));
    }
  }
  _observeInitialPoint(point_vo) {
    this._initial_point_vo = point_vo;
    this._notifyInitialPoint(this._initial_point_vo);
  }
  _observeInitialPointIsShow(is_show) {
    this._initial_point_is_show = is_show;
    this._notifyInitialPointIsShow(this._initial_point_is_show);
  }
  _observeInitialPointIsSelected(is_selected) {
    this._initial_point_is_selected = is_selected;
    this._notifyInitialPointIsSelected(this._initial_point_is_selected);
  }
}
